// src/components/MetodosPago.jsx
import React, { useEffect, useState } from "react";
import clienteAxios from "../../axios";
import ModalConfirm from "../ModalConfirm";
import ModalAgregarMetodoPago from "./ModalAgregarMetodoPago";

const MetodosPago = ({ transaccionId }) => {
    const [metodosPago, setMetodosPago] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [metodoSeleccionado, setMetodoSeleccionado] = useState(null);
    const [editandoMetodo, setEditandoMetodo] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [nuevoMetodo, setNuevoMetodo] = useState({ nombre_metodo: "" });
    const [showAgregarMetodoForm, setShowAgregarMetodoForm] = useState(false);
    const [showAgregarMetodoModal, setShowAgregarMetodoModal] = useState(false);

    // Obtener la lista de métodos de pago
    const obtenerMetodosPago = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "metodos_pago"
            });
            setMetodosPago(response.data.data[0]);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        obtenerMetodosPago();
    }, [transaccionId]);

    // Función para manejar la búsqueda
    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    // Filtrar métodos de pago según la barra de búsqueda
    const metodosFiltrados = metodosPago.filter((metodo) =>
        metodo.nombre_metodo.toLowerCase().includes(busqueda)
    );

    // Función para iniciar la edición de un método de pago
    const editarMetodo = (metodo) => {
        setEditandoMetodo(metodo);
    };

    const handleAbrirAgregarMetodoModal = () => {
        setShowAgregarMetodoModal(true);
    };

    const handleCerrarAgregarMetodoModal = () => {
        setShowAgregarMetodoModal(false);
    };


    // Guardar los cambios del método de pago editado
    const guardarMetodoEditado = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "metodos_pago",
                id: editandoMetodo.id,
                nombre_metodo: editandoMetodo.nombre_metodo,
            });
            setEditandoMetodo(null);
            obtenerMetodosPago();
        } catch (error) {
            console.log(error);
        }
    };

    // Confirmar la eliminación de un método de pago
    const confirmarEliminarMetodo = (metodo) => {
        setMetodoSeleccionado(metodo);
        setShowConfirmModal(true);
    };

    // Eliminar el método de pago
    const eliminarMetodo = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar",
                modulo: "metodos_pago",
                id: metodoSeleccionado.id
            });
            setShowConfirmModal(false);
            obtenerMetodosPago();
        } catch (error) {
            console.log(error);
        }
    };



    return (
        <div>

            <ModalAgregarMetodoPago
                show={showAgregarMetodoModal}
                onClose={handleCerrarAgregarMetodoModal}
                onMetodoAgregado={obtenerMetodosPago} // Actualiza la lista tras agregar un método
            />
            
            <div className="mt-4 border p-4 rounded-lg">
                <h3 className="text-lg font-semibold">Métodos de Pago</h3>

                {/* Barra de búsqueda */}
                <input
                    type="text"
                    placeholder="Buscar método de pago..."
                    value={busqueda}
                    onChange={handleBusqueda}
                    className="border rounded-lg p-2 mb-4 mt-2 w-1/2 min-w-[200px]"
                />

                {/* Botón para mostrar el formulario de agregar método */}
                <button
                    onClick={handleAbrirAgregarMetodoModal}
                    className="bg-blue-500 text-white rounded px-4 py-2 mt-4 ml-6 hover:bg-blue-400"
                >
                    Agregar Nuevo Método
                </button>

                <ul>
                    {metodosFiltrados.map((metodo) => (
                        <li key={metodo.id} className="border p-2 mb-2 mt-4">
                            {editandoMetodo && editandoMetodo.id === metodo.id ? (
                                <div className="flex flex-col">
                                    <h3 className=" font-semibold mt-2">Método de Pago:</h3>
                                    <input
                                        type="text"
                                        value={editandoMetodo.nombre_metodo}
                                        onChange={(e) =>
                                            setEditandoMetodo({ ...editandoMetodo, nombre_metodo: e.target.value })
                                        }
                                        className="border rounded-lg p-2 mr-2"
                                        maxLength={20}
                                    />
                                    <div className="flex mt-4 mb-2">
                                        <button
                                            onClick={guardarMetodoEditado}
                                            className="bg-green-500 text-white rounded px-2 py-1 mt-2 w-40 mr-2"
                                        >
                                            Guardar
                                        </button>
                                        <button
                                            onClick={() => setEditandoMetodo(null)}
                                            className="bg-gray-500 text-white rounded px-2 py-1 mt-2 w-40 mr-2"
                                        >
                                            Cancelar
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <span><strong>Método de Pago:</strong> {metodo.nombre_metodo}</span><br />
                                    <span><strong>ID:</strong> {metodo.id}</span><br />
                                    <button
                                        onClick={() => editarMetodo(metodo)}
                                        className="bg-gray-500 text-white rounded px-2 py-1 mt-2 hover:bg-gray-400"
                                    >
                                        Editar
                                    </button>
                                    <button
                                        onClick={() => confirmarEliminarMetodo(metodo)}
                                        className="bg-red-600 text-white rounded px-2 py-1 mt-2 ml-2 hover:bg-red-500"
                                    >
                                        Eliminar
                                    </button>
                                </>
                            )}
                        </li>
                    ))}
                </ul>
            </div>

            {/* Modal de confirmación */}
            <ModalConfirm
                show={showConfirmModal}
                message="¿Estás seguro de que quieres eliminar este método de pago?"
                onConfirm={eliminarMetodo}
                onCancel={() => setShowConfirmModal(false)}
            />
        
        </div>
    );
};

export default MetodosPago;
